var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{attrs:{"absolute":"","z-index":"0","color":"white","opacity":0.9,"value":_vm.value}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary","size":"26"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }